import React, { useEffect, Dispatch, SetStateAction } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import LoadingContent from "../../../components/LoadingContent";
import { countryCodeToFlag } from "../../../utils/Admin";

interface XProps {
  data: any;
  xEmbed: string;
  setXEmbed: Dispatch<SetStateAction<string>>;
  onIndividualSubmit: () => void; // Recibido desde el padre para el envío 1 a 1
  uploading: boolean; // Recibido desde el padre para controlar el spinner individual
}

const UploadRaceX = ({
  data,
  xEmbed,
  setXEmbed,
  onIndividualSubmit,
  uploading,
}: XProps) => {
  const MAX_CHARS = 280;

  const charCount = xEmbed.length;
  const isOverLimit = charCount > MAX_CHARS;

  const getRaceName = (length: number, type_race: number) => {
    if (length === 2 && type_race === 1) return "Main Race";
    else if (length === 2 && type_race === 2) return "Sprint Race";
  };

  useEffect(() => {
    if (!data || !data.winners) return;

    setXEmbed(
      data.winners.length === 1
        ? [
            `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
            "",
            `${
              data.winners[0].flag_code
                ? countryCodeToFlag(data.winners[0].flag_code)
                : "🏁"
            } ${data.winners[0].username} takes the victory 🏆`,
            `${
              data.race_results[1].flag_code
                ? countryCodeToFlag(data.race_results[1].flag_code)
                : "🏁"
            } ${data.race_results[1].username} (2º) 🥈`,
            `${
              data.race_results[2].flag_code
                ? countryCodeToFlag(data.race_results[2].flag_code)
                : "🏁"
            } ${data.race_results[2].username} (3º) 🥉`,
            "",
            `🔗 Race results: ${data.results_link}`,
          ].join("\n")
        : data.winners[0].class_name == null
          ? [
              `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
              "",
              ...data.winners.map((winner: any) => {
                const flag = winner.flag_code
                  ? countryCodeToFlag(winner.flag_code)
                  : "🏁";

                const position = "🏆";

                return `${flag} ${winner.username} in ${getRaceName(
                  data.winners.length,
                  winner.type_race,
                )} ${position}`;
              }),
              "",
              `🔗 Race results: ${data.results_link}`,
            ].join("\n")
          : [
              `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} ${data.grand_prix.name.toUpperCase()} is over.`,
              "",
              ...data.winners.map((winner: any, index: number) => {
                const flag = winner.flag_code
                  ? countryCodeToFlag(winner.flag_code)
                  : "🏁";
                return `🏆 ${winner.class_name} Winner: ${flag} ${winner.username}`;
              }),
              "",
              `🔗 Race results: ${data.results_link}`,
            ].join("\n"),
    );
  }, [data, setXEmbed]);

  if (data == null) return <LoadingContent />;

  return (
    // Transformado de <Form> a un <div> plano para que conviva dentro del formulario padre
    <div className="x-form mb-4 p-3 border rounded shadow-sm">
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            <FontAwesomeIcon icon={faXTwitter} className="me-2" /> X [Including
            GP Image]
          </h4>
        </Form.Group>

        <Form.Group className="form-group" as={Col} md="12">
          <div
            style={{
              marginTop: "6px",
              fontSize: "13px",
              textAlign: "right",
              color: isOverLimit ? "red" : "#888",
              fontWeight: isOverLimit ? "bold" : "normal",
            }}
          >
            {charCount} / {MAX_CHARS}
          </div>
          <Form.Label>Tweet (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="x_embed"
            rows={6}
            value={xEmbed}
            onChange={(e) => setXEmbed(e.target.value)}
            isInvalid={isOverLimit}
          />
          <Form.Control.Feedback type="invalid">
            Field required o excess characters
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Botón exclusivo para enviar únicamente a X */}
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" spin />
        ) : (
          <Button
            type="button" // Evita disparar el onSubmit del formulario masivo del componente padre
            variant="secondary"
            onClick={onIndividualSubmit}
            disabled={isOverLimit}
          >
            Send X Tweet Only
          </Button>
        )}
      </div>
    </div>
  );
};

export default UploadRaceX;
